module.exports = __webpack_public_path__ + "img/hands-holding-heart.c495f283.svg";